import type { IconProps } from '../types/IconProps.ts';
export const CodeXml: IconProps = {
    name: 'CodeXml',
    children: [
        `<path d="m18 8 3.86 3.86a.2.2 0 0 1 0 .28L18 16M6 8l-3.86 3.86a.2.2 0 0 0 0 .28L6 16M14 4l-4 16" />`,
    ]
};